import React from "react";
import "../styles/components/ChangelogEntry.css";
import PropTypes from "prop-types";
import DOMPurify from "isomorphic-dompurify";

// blog posts include id, title, date posted, and body

const ChangelogEntry = (props) => {
  const sanitizeEntries = () => {
    const list = props.body.map((entry) => {
      const safeText = DOMPurify.sanitize(entry);
      return safeText;
    });
    return list;
  };

  const formatEntries = () => {
    const safeEntries = sanitizeEntries();
    let entryString = "";
    for (const entry of safeEntries) {
      entryString += `<li>${entry}</li>`;
    }
    return { __html: entryString };
  };

  const bodyText = formatEntries();
  return (
    <div key={props.id}>
      <small>{props.date}</small>
      <p dangerouslySetInnerHTML={bodyText}></p>
    </div>
  );
};

ChangelogEntry.propTypes = {
  id: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  body: PropTypes.array.isRequired,
};

export default ChangelogEntry;
